/* eslint-disable no-console */
export const getCookie = (
  name: string,
  checkSessionStorageFirst = false
): string | boolean | null | undefined => {
  try {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const cookieValue = checkSessionStorageFirst && sessionStorage.getItem(name)
      ? sessionStorage.getItem(name)
      : decodeURIComponent(
        ('; ' + document.cookie)
          ?.split('; ' + name + '=')
          ?.pop()
          ?.split(';')
          ?.shift()
      );

    return cookieValue === 'true' || cookieValue === 'false'
      ? JSON.parse(cookieValue)
      : cookieValue;
  } catch (error) {
    console.error(`Error getting cookie ${name}: `, error);
    return undefined;
  }
};

const mockNativeApp = () => {
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage && localStorage.getItem && localStorage.getItem('MOCK_NATIVE_APP');
    }
    return false;
  } catch (error) {
    return false;
  }
};

// cookie thd_online_channel value is e1=s1, for native app
const isNativeAppFromCookie = () => {
  const encodedNative = 'e1%3ds1';
  const cookie = document.cookie.toLowerCase();
  return (
    (cookie && cookie.indexOf('thd_online_channel') > -1 && cookie.indexOf(encodedNative) > -1)
    || mockNativeApp()
  );
};

export const isNativeApp = () => {
  try {
    // isNil checks for the values 'null' or 'undefined'
    const channelTypeElement = document?.getElementById('channel_type');
    const isChannelTypeNil = channelTypeElement === null || channelTypeElement === undefined;
    const channelType = isChannelTypeNil ? 'desktop' : channelTypeElement?.value;
    return channelType.toUpperCase() === 'MOBILEAPP' || mockNativeApp() || false;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('napp channel detection exception', error);
    return isNativeAppFromCookie();
  }
};

export const findNativeAppEnvironment = () => (isNativeIOS() === true ? 'IOS' : 'ANDROID');

const isNativeIOS = () => {
  const encodedOS = 'e2%3dios';
  const encodedClientApp = 'e4%3dcnative';
  const cookie = document.cookie.toLowerCase();
  return (
    cookie
    && cookie.indexOf('thd_online_channel') > -1
    && cookie.indexOf(encodedOS) > -1
    && cookie.indexOf(encodedClientApp) > -1
  );
};

// Generate UUID for x-trace-uuid
export const generateUUID = (): string => {
  return Math.random().toString(36).substring(2, 15);
};

// Format gift card number by masking first 4 and last 7 digits with asterisks
export const formatGiftCardNumber = (giftCardNumber: string): string => {
  if (!giftCardNumber || giftCardNumber.length !== 12 || !/^\d{12}$/.test(giftCardNumber)) {
    return '**** ****** ****** *******'; // Return all stars if not exactly 12 digits
  }

  const firstFourMasked = '****';
  const firstSixDigits = giftCardNumber.slice(0, 6); // First 6 of the 12 digits
  const lastSixDigits = giftCardNumber.slice(6); // Last 6 of the 12 digits
  const lastSevenMasked = '*******';

  return `${firstFourMasked} ${firstSixDigits} ${lastSixDigits} ${lastSevenMasked}`;
};
